import { OpenAI } from '@maximizer/core/shared/domain';
import { AnonymizeRequest, PIIContext } from './pii-anonymization.types';
import { IQBoostConversationMessages } from './iqBoost';

export class PiiAnonymizationHelpers {
  static toAnonymizeRequest(messages: OpenAI.GPTMessage[], piiContext?: PIIContext): AnonymizeRequest {
    return {
      PIIContext: piiContext?.contacts ?? [],
      Texts: messages.map((message) => message.content),
    };
  }

  static toOpenAiMessages(messages: OpenAI.GPTMessage[], texts: string[] | undefined): OpenAI.GPTMessage[] {
    if (!texts?.length) {
      return [];
    }

    return messages.map((message, index) => ({
      ...message,
      content: texts[index] ?? message.content,
    }));
  }

  static splitConversationMessages(
    anonymizedMessages: OpenAI.GPTMessage[],
    contextCount: number,
    userCount: number,
  ): IQBoostConversationMessages {
    return {
      context: anonymizedMessages.slice(0, contextCount),
      user: anonymizedMessages.slice(contextCount, contextCount + userCount),
      system: anonymizedMessages.slice(contextCount + userCount),
    };
  }

  static processPiiMaskTokensInHtml(
    htmlText: string,
    transformFn: (type: string, number: string, match: string) => string,
  ): string {
    if (!htmlText) return '';

    const angleBracketMaskPattern = /(?:<|&lt;)([A-Z]+)(\d+)(?:>|&gt;)/g;
    let m: RegExpExecArray | null;
    angleBracketMaskPattern.lastIndex = 0;
    let out = '';
    let last = 0;
    while ((m = angleBracketMaskPattern.exec(htmlText)) !== null) {
      out += htmlText.slice(last, m.index);
      const full = m[0];
      const type = m[1];
      const number = m[2];
      out += transformFn(type, number, full);
      last = m.index + full.length;
    }
    return out + htmlText.slice(last);
  }

  static wholeWordPattern(original: string): RegExp {
    const escaped = PiiAnonymizationHelpers.escapeRegExp(original);
    const wb = String.raw`\b`;
    return new RegExp(`${wb}${escaped}${wb}`, 'gi');
  }

  private static escapeRegExp(value: string): string {
    return value.replaceAll(/[.*+?^${}()|[\]\\]/g, (ch) => `\\${ch}`);
  }
}
